module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/e92a1618cc1969b23db6a20499547599.png";